import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/joy";
import { useFollowStore } from "../../store/followStore";

interface FollowButtonProps {
  targetUserId: string;
}

export const FollowButton: React.FC<FollowButtonProps> = ({ targetUserId }) => {
  const { isFollowing, followUser, unfollowUser, loading } = useFollowStore();
  const [isHovering, setIsHovering] = useState(false);
  const following = isFollowing(targetUserId);

  const handleClick = async () => {
    if (following) {
      await unfollowUser(targetUserId);
    } else {
      await followUser(targetUserId);
    }
  };

  return (
    <Button
      data-testid={`follow-button-${targetUserId}`}
      variant={following ? "outlined" : "solid"}
      color={following && isHovering ? "danger" : "primary"}
      onClick={handleClick}
      disabled={loading}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      startDecorator={loading ? <CircularProgress size="sm" /> : undefined}
      sx={{ minWidth: 100 }}
    >
      {loading
        ? ""
        : following
          ? isHovering
            ? "Unfollow"
            : "Following"
          : "Follow"}
    </Button>
  );
};
